import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { User } from 'src/app/models/data/user.model';
import { AuthService } from 'src/app/services/auth/auth.service';
import { EmbeddedAlertComponent } from '../../shared/embedded-alert/embedded-alert.component';

@Component({
  selector: 'app-email-change-form',
  templateUrl: './email-change-form.component.html',
  styleUrls: ['./email-change-form.component.css'],
  imports: [CommonModule, EmbeddedAlertComponent, ReactiveFormsModule],
})
export class EmailChangeFormComponent implements OnInit {
  @Input() authenticatedUser!: User;

  emailForm!: FormGroup;
  error!: string | null;
  success: any;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.emailForm = this.fb.group({
      email: [this.authenticatedUser?.email || '', [
        Validators.required,
        Validators.email
      ]]
    });
  }

  onSubmit() {
    this.error = null;

    if (this.emailForm.invalid) {
      this.error = 'Please enter a valid email';
      return;
    }

    const email = this.emailForm.value.email;
    this.authService.changeEmail(email).subscribe(
      (res) => {
        console.log(res);
        if (res == null) {
          this.success = 'Email changed successfully!';
        }
      },
      (errorMessage: any) => {
        if (errorMessage) {
          this.error = 'Server error';
        }
      },
    );
  }
}
